// @flow
const CREATE_CERT_REQUEST = 'admin/cert/CREATE_CERT_REQUEST_STATUS';
const CREATE_CERT_REQUEST_SUCCESS = 'admin/cert/CREATE_CERT_REQUEST_SUCCESS';
const CREATE_CERT_REQUEST_FAIL = 'admin/cert/CREATE_CERT_REQUEST_FAIL';
const DELETE_CERT_REQUEST = 'admin/cert/DELETE_CERT_REQUEST_STATUS';
const DELETE_CERT_REQUEST_SUCCESS = 'admin/cert/DELETE_CERT_REQUEST_SUCCESS';
const DELETE_CERT_REQUEST_FAIL = 'admin/cert/DELETE_CERT_REQUEST_FAIL';
const GET_CERT_STATUS = 'admin/cert/GET_CERT_STATUS';
const GET_CERT_STATUS_SUCCESS = 'admin/cert/GET_CERT_STATUS_SUCCESS';
const GET_CERT_STATUS_FAIL = 'admin/cert/GET_CERT_STATUS_FAIL';
const IMPORT_CERT = 'admin/cert/IMPORT_CERT';
const IMPORT_CERT_SUCCESS = 'admin/cert/IMPORT_CERT_SUCCESS';
const IMPORT_CERT_FAIL = 'admin/cert/IMPORT_CERT_FAIL';

export {
  CREATE_CERT_REQUEST,
  CREATE_CERT_REQUEST_SUCCESS,
  CREATE_CERT_REQUEST_FAIL,
  DELETE_CERT_REQUEST,
  DELETE_CERT_REQUEST_SUCCESS,
  DELETE_CERT_REQUEST_FAIL,
  GET_CERT_STATUS,
  GET_CERT_STATUS_FAIL,
  GET_CERT_STATUS_SUCCESS,
  IMPORT_CERT,
  IMPORT_CERT_FAIL,
  IMPORT_CERT_SUCCESS,
};

export type CertStatus = {};

export type CertInfo = {
  owner?: string,
  issuer?: string,
  startDate?: string,
  endDate?: string,
  subjectAlternativeNames?: string[],
};

export type CertRequestData = {
  FQDN?: string,
  organizationalUnit?: string,
  organizationName?: string,
  cityOrLocality?: string,
  stateOrProvince?: string,
  countryCode?: string,
  subjectAlternativeNames?: string,
  timestamp?: string,
};

export type CertState = {
  certificate?: CertInfo,
  request?: CertRequestData,
};

export type CertUpload = {
  mainCertFile?: any,
  intermediateCertFile1?: any,
  intermediateCertFile2?: any,
  rootCertFile?: any,
  password?: string,
};

type CreateCertRequestAction = {|
  type: 'admin/cert/CREATE_CERT_REQUEST',
  payload: { session: string },
|};

type CreateCertRequestSuccessAction = {|
  type: 'admin/cert/CREATE_CERT_REQUEST_SUCCESS',
  payload: { certificate: CertInfo, request: CertRequestData },
|};

type CreateCertRequestFailAction = {|
  type: 'admin/cert/CREATE_CERT_REQUEST_FAIL',
|};

type DeleteCertRequestAction = {|
  type: 'admin/cert/DELETE_CERT_REQUEST',
  payload: { session: string },
|};

type DeleteCertRequestSuccessAction = {|
  type: 'admin/cert/DELETE_CERT_REQUEST_SUCCESS',
|};

type DeleteCertRequestFailAction = {|
  type: 'admin/cert/DELETE_CERT_REQUEST_FAIL',
|};

type GetCertStatusAction = {|
  type: 'admin/cert/GET_CERT_STATUS',
|};

type GetCertStatusSuccessAction = {|
  type: 'admin/cert/GET_CERT_STATUS_SUCCESS',
  payload: { certificate: CertInfo, request: CertRequestData },
|};

type GetCertStatusFailAction = {|
  type: 'admin/cert/GET_CERT_STATUS_FAIL',
|};

type UploadCertAction = {|
  type: 'admin/cert/IMPORT_CERT',
|};

type UploadCertSuccessAction = {|
  type: 'admin/cert/IMPORT_CERT_SUCCESS',
  payload: { certificate: CertInfo, request: CertRequestData },
|};

type UploadCertFailAction = {|
  type: 'admin/cert/IMPORT_CERT_FAIL',
|};

export type Action =
  | CreateCertRequestAction
  | CreateCertRequestFailAction
  | CreateCertRequestSuccessAction
  | DeleteCertRequestAction
  | DeleteCertRequestFailAction
  | DeleteCertRequestSuccessAction
  | GetCertStatusAction
  | GetCertStatusFailAction
  | GetCertStatusSuccessAction
  | UploadCertAction
  | UploadCertFailAction
  | UploadCertSuccessAction;



// WEBPACK FOOTER //
// ./src/state/types/certTypes.js